import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=2bc526b5&"
import script from "./PasswordForgotten.vue?vue&type=script&lang=ts&"
export * from "./PasswordForgotten.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports